var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 13,
    viewBox: "0 0 37 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.25 2.5C16.05 2.5 14.25 4.3 14.25 6.5C14.25 8.7 16.05 10.5 18.25 10.5C20.45 10.5 22.25 8.7 22.25 6.5C22.25 4.3 20.45 2.5 18.25 2.5ZM30.25 2.5C28.05 2.5 26.25 4.3 26.25 6.5C26.25 8.7 28.05 10.5 30.25 10.5C32.45 10.5 34.25 8.7 34.25 6.5C34.25 4.3 32.45 2.5 30.25 2.5ZM6.25 2.5C4.05 2.5 2.25 4.3 2.25 6.5C2.25 8.7 4.05 10.5 6.25 10.5C8.45 10.5 10.25 8.7 10.25 6.5C10.25 4.3 8.45 2.5 6.25 2.5Z",
    fill: "#183059"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionsIcon);
export default __webpack_public_path__ + "static/media/Actions_icon.52db01a8f9823a0c03e0c0aad661001d.svg";
export { ForwardRef as ReactComponent };